<template>
    <div :class="isLoading ? 'is-loading' : ''">

        <!-- list -->
        <div data-pagination-change-scroll-to>

            <p v-if="!displayedItems.length && !isLoading" class="text-center mb-4">
                {{ translate('No items available') }}
            </p>

            <article v-for="article in displayedItems" :key="article.id" class="link-list-item mb-3">
                <a :href="article.link" class="stretched-link"></a>
                <div class="d-flex">
                    <div class="link-list-item--image rounded-1 overflow-hidden">
                        <img :src="getArticleImage(article.image)" :alt="article.heading" class="img-fluid">
                    </div>
                    <div class="min-w-0 flex-grow-1 px-4 py-3">
                        <p class="text-secondary fw-semibold">
                            <small class="text-nowrap">
                                {{ article.date }}
                            </small>
                        </p>
                        <h3 class="text-truncate h6 my-2">
                            {{ article.heading }}
                        </h3>
                        <p class="text-truncate-lines-3">
                            {{ article.perex }}
                        </p>
                    </div>
                    <div class="flex-shrink-0 d-none d-md-flex align-items-center">
                        <div class="post-arrow">
                            <svg class="icon-post-arrow">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </article>

        </div>

        <div class="mt-5 d-print-none">
            <Pagination 
                :items-count="articles.length"
                v-model:current-page="pagination.currentPage" 
                v-model:per-page="pagination.perPage"
            />
        </div>

    </div>
</template>

<script>
import { paginate } from '@/scripts/helpers/pagination';
import { translate } from '@/scripts/mixins/translations';
import Pagination from '@/components/pagination/Pagination.vue';

export default {
    components: {
        Pagination
    },
    mixins: [
        translate
    ],
    data(){
        return {
            isLoading: false,
            pagination: {
                currentPage: 1,
                perPage: parseInt(localStorage.getItem('list-per-page')) || 10
            },
            articles: []
        }
    },
    methods: {
        getArticleImage(url){
            if ( url.length )
            {
                return url;
            }

            return '/client-assets/public/images/tc-placeholder.svg';
        },
        loadArticles(){
            this.isLoading = true;

            axios.get(`media/pressreleases`)
            .then(response => {
                const { data } = response;

                this.articles = data;
            })
            .finally(() => {
                this.isLoading = false;
            });
        }
    },
    computed: {
        displayedItems(){
            return paginate(this.articles, this.pagination.currentPage, this.pagination.perPage);
        }
    },
    mounted(){
        this.loadArticles();
    }
}
</script>